import { combineReducers } from "redux";
import theme from "./theme/themeSlice";
import auth from "./auth";
import base from "./base";
import flow from "./studio/slice";
import rightPanel from "./studio/propertiesSlice";
import market from "./market";
import { modelEngineService } from "../services/ModelEngineService";
import { datasetService } from "../services/DatasetService";
import { marketplaceService } from "../services/MarketplaceService";
import dataVisuals from "./dataVisuals/visualsModalSlice";
import { otherServiceApi } from "../services/OtherServices";
import { billingApi } from "../services/BillingService";
import { projectService, channelService } from "../services/ProjectService";
import { modelService } from "../services/ModelService";
import { authService } from "../services/AuthService";
import { competitionService } from "../services/competitionService";
import { logServices } from "../services/LogService";
import { CommonService } from "../services/CommonService";
import { appSlice } from './app/slice';
import { wizardSlice } from '../views/WizardStudio/slice';
import { labelCraftSlice } from '../views/LabelCraft/slice';
import { labelCraftServiceApi } from '../services/LabelCraftServices';
import { customerServiceApi } from "services/CustomerService";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    base,
    dataVisuals,
    flow,
    market,
    rightPanel,
    app: appSlice.reducer,
    wizard: wizardSlice.reducer,
    labelcraft: labelCraftSlice.reducer,

    [authService.reducerPath]: authService.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [modelEngineService.reducerPath]: modelEngineService.reducer,
    [datasetService.reducerPath]: datasetService.reducer,
    [marketplaceService.reducerPath]: marketplaceService.reducer,
    [otherServiceApi.reducerPath]: otherServiceApi.reducer,
    [projectService.reducerPath]: projectService.reducer,
    [modelService.reducerPath]: modelService.reducer,
    [logServices.reducerPath]: logServices.reducer,
    [CommonService.reducerPath]: CommonService.reducer,
    [labelCraftServiceApi.reducerPath]: labelCraftServiceApi.reducer,
    [competitionService.reducerPath]: competitionService.reducer,
    [customerServiceApi.reducerPath]: customerServiceApi.reducer,
    [channelService.reducerPath]: channelService.reducer,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
